import { CompanyContextService } from '@skylab-shared/core';
import { CacheStorage } from './cache-storage/cache-storage.service';
import { CommandBus } from "./command/command-bus.service";
import { EventBus } from "./event/event-bus.service";
import { FeatureFlagsRulesService } from "./feature-flags/feature-flags-rules.service";
import { Http } from "./http/http.service";
import { EnumTranslator } from "./l10n/enum-translator.service";
import { L10n } from "./l10n/l10n.service";
import { QueryBus } from "./query/query-bus.service";
import { RootContext } from "./root-context/root-context.service";
import { Weaver } from "./weaver/weaver.service";

export const coreProviders = [
	Http,
	QueryBus,
	CacheStorage,
	RootContext,
	EventBus,
	CommandBus,
	EnumTranslator,
	Weaver,
	L10n,
	FeatureFlagsRulesService,
	CompanyContextService
];
